import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from '@home/pages/home/home.component';
import { ResearchAuthGuard } from '@core/authentication';
import { LoginComponent } from '@home/pages/login/login.component';

ResearchAuthGuard.loginRoute = '/login';
const routes: Routes = [
    { path: 'home', component: HomeComponent, canActivate: [ResearchAuthGuard] },
    { path: 'login', component: LoginComponent },
    {
        path: 'reporting',
        canActivate: [ResearchAuthGuard],
        loadChildren: () => import('@reporting/reporting.module').then(m => m.ReportingModule)
    },
    {
        path: 'permitting',
        canActivate: [ResearchAuthGuard],
        loadChildren: () => import('@permitting/permitting.module').then(m => m.PermittingModule)
    },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: '**', redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
